<template lang="pug">
.damo-card
  img(src="~assets/icons/exps/5g.jpg")
  .copy
</template>
<script>
export default {
  name: 'ForestCard',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.damo-card
  width: 100%
  height: 100%
  img
    width: 100%
    height: 100%
    object-fit: cover
</style>
